export { createMutationQuery } from "../../query/execution/mutation.ts";
